// Carries the current URL's params (marketing tags, guests/date) into the product page opened in a
// new tab.
// ponytail: the legacy grids mount on DOMContentLoaded and are never prerendered, so reading the
// live URL is safe here. The prerendered grid2 gets its query string from ProductLinksHelper instead.
export const withLinkParams = path => path + window.location.search

export default withLinkParams
